<template>
  <!-- 预售活动添加/编辑表单 -->
  <div class="presellForm">
    <page-header @back="goBack" :title="$route.meta.title"></page-header>
    <el-scrollbar style="height:calc(100% - 50px)">
      <div style="height:20px;"></div>
      <el-form ref="addForm" :model="addForm" :rules="addFormRules" label-width="120px">
        <el-form-item label="标题" prop="title">
          <el-input v-model="addForm.title" style="width: 200px" placeholder="请输入标题"></el-input>
        </el-form-item>
        <el-form-item label="开始时间" prop="startTime">
          <el-date-picker v-model="addForm.startTime" style="width:200px;" type="datetime" format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss" placeholder="开始时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间" prop="endTime">
          <el-date-picker v-model="addForm.endTime" style="width:200px;" type="datetime" format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss" placeholder="结束时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="客户类型" prop="userType">
          <el-checkbox-group v-model="addForm.userType" style="width: 1000px">
            <el-checkbox v-for="item in userTypeList" :key="item.value" :label="item.value">
              {{ item.label }}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item> 
        <el-form-item label="活动商品" prop="list">
          <el-button type="primary" icon="el-icon-circle-plus-outline" @click="goodsDialog = true">添加商品</el-button>
        </el-form-item>
        <el-form-item>
          <el-table :data="addForm.list" stripe border tooltip-effect="dark">
            <el-table-column label="序号" align="center" width="50" type="index">
            </el-table-column>
            <el-table-column prop="name" align="center" show-overflow-tooltip label="商品名称">
            </el-table-column>
            <el-table-column prop="quantity" align="center" label="数量">
              <template slot-scope="scope">
                <div>
                  <el-input-number v-model="scope.row.quantity" :min="1" :max="100000000"
                    :precision="0"></el-input-number>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="price" align="center" label="活动价格">
              <template slot-scope="scope">
                <div>
                  <el-input-number v-model="scope.row.price" :min="0.01" :max="100000000"
                    :precision="2"></el-input-number>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="discount" align="center" label="折扣">
              <template slot-scope="scope">
                <div>
                  <el-input-number v-model="scope.row.discount" :min="1" :max="100" :precision="0"></el-input-number>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button type="danger" style="padding: 2px 3px" plain @click="handleDelGoods(scope)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item label="区域控销" prop="limitArea">
          <el-select v-model="addForm.limitArea" placeholder="区域控销" style="width: 200px; margin-right: 5px">
            <el-option label="无限制" value="0"></el-option>
            <el-option label="指定白名单" value="1"></el-option>
            <el-option label="指定黑名单" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-show="addForm.limitArea != 0" label="选择区域" prop="areaValue">
          <div style="width: 800px">
            <div>
              <el-tag v-for="(item, index) in addForm.areaValue" :key="index" closable @close="onTagClose(index)"
                type="success" effect="dark" :disable-transitions="false" class="my-el-tag"
                style="margin-bottom: 5px">{{ item.label }}
              </el-tag>
            </div>
            <el-button type="primary" @click="areaDialog = true">增加区域</el-button>
          </div>
        </el-form-item>
        <el-form-item label="客户控销" prop="customerLimit">
          <el-select v-model="addForm.customerLimit" placeholder="请选择" style="width: 200px; margin-right: 5px">
            <el-option label="无限制" value="0"></el-option>
            <el-option label="指定白名单" value="1"></el-option>
            <el-option label="指定黑名单" value="2"></el-option>
          </el-select>
          <el-select v-if="addForm.customerLimit != 0" v-model="addForm.customerGroup" placeholder="请选择"
            style="width: 200px" filterable clearable multiple>
            <el-option v-for="item in groupList" :key="item.GroupId" :label="item.GroupName" :value="item.GroupId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="">
          <!-- 禁用状态下显示保存按钮 -->
          <el-button v-if="addForm.status == 1" type="primary" @click="handleSubmitGoods">保存</el-button>
        </el-form-item>
      </el-form>
    </el-scrollbar>


    <!-- 商品表格 -->
    <!-- <el-dialog title="添加商品" :visible.sync="addGoodsDialog" :close-on-click-modal="$store.state.closeOnClickModal"
      :close-on-press-escape="$store.state.closeOnPresEscape" width="800px">
     
      <div slot="footer">
        <el-button type="primary" @click="goodsDialog = true">添加商品</el-button>
        <el-button type="primary" @click="handleSubmitGoods">提交</el-button>
      </div>
    </el-dialog> -->

    <!-- 商品表格 -->
    <el-dialog title="商品列表" :visible.sync="goodsDialog" :close-on-click-modal="$store.state.closeOnClickModal"
      :close-on-press-escape="$store.state.closeOnPresEscape" width="800px">
      <search-bar>
        <template>
          <el-input style="width: 200px; margin-right: 5px" clearable placeholder="输入商品名称" v-model="goodsName"
            @keydown.native.enter="getGoodsList('search')">
          </el-input>
          <el-button type="primary" icon="el-icon-search" @click="getGoodsList('search')">搜索</el-button>
        </template>
      </search-bar>
      <el-table :data="goodsList" stripe border tooltip-effect="dark" height="300px">
        <el-table-column label="序号" type="index" align="center" width="50">
        </el-table-column>
        <el-table-column prop="code" align="center" width="160" show-overflow-tooltip label="ERP商品编号">
        </el-table-column>
        <el-table-column prop="name" align="center" width="160" show-overflow-tooltip label="商品名称">
        </el-table-column>
        <el-table-column prop="entname" align="center" show-overflow-tooltip label="机构名称">
        </el-table-column>
        <el-table-column prop="specification" label="商品规格" width="120" align="center" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="packingNnit" label="包装单位" align="center" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="producer" label="生产厂家" width="120" align="center" show-overflow-tooltip>
        </el-table-column>
        <el-table-column label="操作" align="center" width="100" fixed="right">
          <template slot-scope="scope">
            <el-button type="primary" style="padding: 2px 3px" plain @click="handleGoodsItem(scope)">添加</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination :allPage="allPage2" :pageSize="pageSize2" :currIndex="currPage2" @hanSiChange="hanSiChange2"
        @hanCurrChange="hanCurrChange2"></pagination>
    </el-dialog>

    <!-- 区域列表数据 -->
    <el-dialog title="区域列表" :visible.sync="areaDialog" :close-on-click-modal="$store.state.closeOnClickModal"
      :close-on-press-escape="$store.state.closeOnPresEscape" width="800px">
      <search-bar>
        <template>
          <el-input style="width: 200px; margin-right: 5px" clearable placeholder="输入区域名称" v-model="areaName"
            @keydown.native.enter="getAreaList('search')">
          </el-input>
          <el-button type="primary" icon="el-icon-search" @click="getAreaList('search')">搜索</el-button>
        </template>
      </search-bar>
      <el-table :data="areaList" stripe border tooltip-effect="dark" height="300px">
        <el-table-column label="序号" type="index" align="center" width="50">
        </el-table-column>
        <el-table-column v-for="(value, key) in areaListHead" :key="key" :prop="key" :label="value" align="center"
          width="160" show-overflow-tooltip>
        </el-table-column>
        <el-table-column label="操作" align="center" width="100" fixed="right">
          <template slot-scope="scope">
            <el-button type="primary" style="padding: 2px 3px" plain @click="handleAreaItem(scope)">添加</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination :allPage="allPage3" :pageSize="pageSize3" :currIndex="currPage3" @hanSiChange="hanSiChange3"
        @hanCurrChange="hanCurrChange3"></pagination>
    </el-dialog>
  </div>
</template>

<script>
//表单验证
import { mustFill } from "@/mixins/data/valid.js";
export default {
  name: 'presellForm',
  data() {
    return {
      /**用户信息 */
      entId: '',//机构id

      /**参数信息 */
      id: '',// 该条数据id
      activityId: '',

      /**表格数据 */
      tableData: [],

      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,

      /**批量绑定商品 */
      /**提交表单 */
      addForm: {
        title: '',//标题
        userType: [],//选中的用户类型
        list: [], //{id、name}//活动商品
        limitArea: "0", // 区域控销
        areaValue: [], // 选中区域
        customerLimit: "0", //是黑名单还是白名单
        customerGroup: [], //选中客户分组id
        startTime: '',//开始时间
        endTime: '',//结束时间
        status: 1,// 1禁用 2启用 0删除，主要用来判断查看或者编辑是否显示保存按钮
      },
      addFormRules: {
        title: [mustFill],
        list: [mustFill],
        startTime: [mustFill],
        endTime: [mustFill]
      },// 表单规则

      /**区域数据 */
      areaDialog: false,//dialog状态
      areaList: [],
      areaListHead: [],//表头信息
      areaName: '',//名称检索
      /**区域列表分页数据 */
      currPage3: 1,
      pageSize3: 20,
      allPage3: 0,

      /**客户分组 */
      groupList: [],

      /**商品数据 */
      goodsName: "", //检索使用，商品名称
      addGoodsDialog: false, //dialog
      goodsDialog: false, //dialog
      goodsList: [], //查询到的商品列表
      /**商品列表分页数据 */
      currPage2: 1,
      pageSize2: 20,
      allPage2: 0,

      /**客户类型 */
      userTypeList: [],

      /**提交表单信息 */
      submitType: 'Add',//提交类型，编辑或者新增 Add/Update
    }
  },
  mounted() {
    /**参数接收 */
    if ('type' in this.$route.query) {
      this.submitType = this.$route.query.type
      this.activityId = this.$route.query.id
      if (this.activityId) {
        this.getData();
      }
    }

    this.entId = window.localStorage.getItem("entId");
    this.getGroupList();
    this.getAreaList();
    this.getUserType();
  },
  methods: {
    /**返回上一页 */
    goBack() {
      this.$router.go(-1);
    },

    /**编辑情况下获取活动详情 */
    getData() {
      let data = {
        activityId: this.activityId
      };

      this.$request({
        url: "/Management/ActivityAdmin/GetActivityDetail",
        method: "post",
        data,
      })
        .then((res) => {
          if (res.success) {
            let { Activity, ActivityControl, ActivityGoods } = res.dataModel
            this.addForm.title = Activity.Title
            this.addForm.startTime = Activity.StartTime
            this.addForm.endTime = Activity.EndTime
            this.addForm.userType = Activity.ClinetType.split(',')
            this.addForm.userType = this.addForm.userType.filter(item => item != '')
            this.addForm.status = Activity.Status

            ActivityControl.forEach(item => {
              if (item.LimitType == 'Area') {
                this.addForm.limitArea = item.Limit + ''//变为字符串

                this.addForm.areaValue.push({
                  label: item.LimitName,
                  value: item.LimitCode
                })
              } else if (item.LimitType == 'Client') {
                this.addForm.customerLimit = item.Limit + ''//变为字符串
                this.addForm.customerGroup.push(parseInt(item.LimitCode))//返回的数据是int类型
              }
            })

            this.addForm.list = ActivityGoods.map(item => {
              return {
                id: item.Id,
                articleId: item.ArticleId,
                name: item.GoodsName,
                quantity: item.Quantity,
                price: item.Price,
                discount: item.Discount
              }
            })
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    /**获取商品列表 */
    getGoodsList(load = '') {
      if (load == "refresh") {
        this.currPage2 = 1;
        this.goodsName = '';
      } else if (load == "search") {
        this.currPage2 = 1;
      }

      let data = {
        type: "GoodsList",
        category: "0",
        attribute: "0",
        status: "2",
        strWhere: this.goodsName,
        PageIndex: this.currPage2,
        PageSize: this.pageSize2,
        promtype: "",
        promstatus: "99",
        goodsPic: "99",
        spStatus: "99",
      };
      let proc = "Proc_Admin_GoodsList"; // 存储过程名
      let type = "ReturnList";
      this.$requestSys({
        url:
          "goods/ashx/ReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
        method: "post",
      })
        .then((res) => {
          this.allPage2 = res.recordCount;
          this.goodsList = [];
          if (res.flag == 0) {
            for (let i = 0; i < res.data.length; i++) {
              this.goodsList.push({
                articleId: res.data[i].article_id,
                code: res.data[i].goodscode,
                name: res.data[i].sub_title,
                entname: res.data[i].entname,
                entid: res.data[i].entId,
                specification: res.data[i].drug_spec,
                packingNnit: res.data[i].package_unit,
                producer: res.data[i].drug_factory,
                classify: res.data[i].category,
                repertory: res.data[i].stock_quantity,
                retailPrice: res.data[i].price,
                validTime: res.data[i].valdate,
                organId: res.data[i].adminentid,
                status: res.data[i].status,
                sort: res.data[i].sort_id,
              });
            }
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },

    /**分页size改变 */
    hanSiChange2(val) {
      this.pageSize2 = val;
      this.getGoodsList();
    },
    /**当前页改变 */
    hanCurrChange2(val) {
      this.currPage2 = val;
      this.getGoodsList();
    },

    /**选中某一个商品 */
    handleGoodsItem({ row }) {
      // 判断数组中是否存该条数据
      let repeat = this.addForm.list.some((item) => item.articleId == row.articleId);
      if (repeat) {
        this.$message({
          message: "该商品已存在",
          type: "warning",
        });
      } else {
        this.$message({
          message: "添加成功",
          type: "success",
          duration: 1000,
        });
        this.addForm.list.push({
          ...row,
          id:'',//这个字段编辑的时候后端会返回，添加的时候默认空
          quantity: 1,//添加一个数量
          price: 0.01,//价格
          discount: 100//折扣
        });
      }
    },

    /**删除选中的某一个商品 */
    handleDelGoods({ $index }) {
      this.addForm.list.splice($index, 1);
    },

    /**区域控销方法 */
    /**标签删除 */
    onTagClose(index) {
      this.addForm.areaValue.splice(index, 1);//在表单字段中进行删除
      // this.addForm[key] = this[keyList].map((item) => item.value).join();
    },

    /**获取区域列表 */
    getAreaList(loadType = 'load') {
      if (loadType == "refresh") {
        this.currPage3 = 1;
        this.areaName = ''
      } else if (loadType == "search") {
        this.currPage3 = 1;
      }

      let data = {
        type: 'RegionListN',
        PageIndex: this.currPage3,
        PageSize: this.pageSize3,
        strWhere: this.areaName,
      };
      let proc = "Proc_Admin_SearchInfo"; //存储过程名
      let type = "ReturnDataSet";
      this.$requestSys({
        method: "post",
        url:
          "ashx/MainReturnJson.ashx?json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&type=" +
          type +
          "&proc=" +
          proc,
      })
        .then((res) => {
          if (res.flag == 0) {
            this.areaList = res.content;
            this.areaListHead = res.fdname;
            this.allPage3 = res.recordCount;
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },

    /**分页size改变 */
    hanSiChange3(val) {
      this.pageSize3 = val;
      this.getAreaList();
    },

    /**当前页改变 */
    hanCurrChange3(val) {
      this.currPage3 = val;
      this.getAreaList();
    },

    /**选中某一个区域 */
    handleAreaItem({ row }) {
      // 判断数组中是否存该条数据
      let repeat = this.addForm.areaValue.some((item) => item.value == row.keyid);
      if (repeat) {
        this.$message({
          message: "该区域已存在",
          type: "warning",
        });
      } else {
        this.$message({
          message: "添加成功",
          type: "success",
          duration: 1000,
        });
        this.addForm.areaValue.push({
          label: row.Area,
          value: row.keyid
        })
      }

    },

    /**客户控销方法 */
    /**获取客户列表 */
    getGroupList() {
      let data = {
        entId: this.entId,
        status: "2",
        searchVal: "", //关键字
        pageIndex: 1,
        pageSize: 999,
      };

      this.$request({
        url: "Member/GetMemberGroup",
        method: "post",
        data,
      })
        .then((res) => {
          this.groupList = res.list;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    /**客户类型获取 */
    getUserType() {
      let data = {
        type: "CustomType",
      };
      let proc = "Proc_Admin_CustomerList"; //存储过程名
      let type = "ReturnList";
      this.$requestSys({
        method: "post",
        url:
          "coupon/ashx/returnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
      })
        .then((res) => {
          if (res.flag == 0) {
            this.userTypeList = res.data.map((item) => {
              return {
                label: item.clienttype,
                value: item.TypeID,
              };
            });
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },

    /**提交商品信息 */
    handleSubmitGoods() {
      if (this.addForm.list.length == 0) {
        this.$message({
          message: "请添加活动商品",
          type: "error",
        });
        return;
      }

      this.$refs["addForm"].validate((valid) => {
        if (valid) {
          // 商品数据
          let ActivityGoods = this.addForm.list.map((item, i) => {
            return {
              Id: item.id ? item.id : '',//传商品中的数据，有的话传，没的话传空
              ActivityId: this.activityId,// 传该条活动的id
              SortId: i + 1,//序号从1开始
              ArticleId: item.articleId,//商品id
              Quantity: item.quantity,//先和TotalQuantity传一样的
              TotalQuantity: item.quantity,
              Price: item.price,//价格
              Discount: item.discount,//折扣
              GoodsName: item.name
            }
          })

          // 控销数据
          let ActivityControl = []

          if (this.addForm.limitArea != 0) {
            this.addForm.areaValue.forEach(item => {
              ActivityControl.push({
                Id: item.Id ? item.Id : '',//该条数据中的id
                ActivityId: this.activityId,//
                LimitType: 'Area',//Area/Client
                Limit: this.addForm.limitArea,
                LimitCode: item.value,
                LimitName: item.label
              })
            })
          }

          if (this.addForm.customerLimit != 0) {
            this.addForm.customerGroup.forEach(item => {
              ActivityControl.push({
                Id: item.Id ? item.Id : '',//该条数据中的id
                ActivityId: this.activityId,//
                LimitType: 'Client',//Area/Client
                Limit: this.addForm.customerLimit,
                LimitCode: item,
                LimitName: '',//前端通过id就可显示出名称，这里就不传了
              })
            })
          }

          let data = {
            EditType: this.submitType,//提交类型，编辑或者新增 Add/Update
            Activity: {
              EntId: this.entId, //机构Id
              ActivityId: this.activityId,// 编辑传入id
              Title: this.addForm.title,//标题
              ActivityType: '预售',//活动类型
              StartTime: this.addForm.startTime,//
              EndTime: this.addForm.endTime,//
              Status: 1,//默认禁用
              ClinetType: this.addForm.userType.join(",") + ",",//客户类型
              AddTime: '',//添加日期 传空
              Lastmodifytime: '',//最后修改日期 传空
            },
            ActivityGoods: ActivityGoods,//活动商品信息
            ActivityControl: ActivityControl
          }


          this.$confirm('确定提交吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$request({
              method: "post",
              url: "/Management/ActivityAdmin/SaveActivityApi",
              data: data
            })
              .then((res) => {
                let type = "success";
                if (res.success) {
                  this.goBack();
                } else {
                  type = "error";
                }

                this.$message({
                  message: res.message,
                  type,
                });
              })
              .catch((err) => {
                window.console.log(err);
              });
          })
        }
      })
    },
  }
}
</script>

<style lang='css' scoped>
.presellForm {
  width: 100%;
  height: 100%;
}
</style>